export const STALE_TOOLTIP =
  "Needs re-run. Inputs changed since this was last computed, so this value may be stale.";
